<template lang="pug">
  .wrap
    .periods
      .button-time(v-for='tab in tabs'
        :class='{ active: mode === tab.name }' :key='tab.name' @click='selectTab(tab.name)') {{ tab.label }}

    .range
      .range-left(@click='changeRange("prev")')
        icon(name="chevron-left" color='#999')

      .range-label
        el-date-picker.picker(:clearable='false' size='large' align='center' v-model='internalDateRange' type="daterange")

      .range-right(@click='changeRange("next")')
        icon(name="chevron-right" color='#999')

</template>

<script>
import _ from "lodash";
import startOfToday from "date-fns/start_of_today";
import startOfWeek from "date-fns/start_of_week";
import endOfWeek from "date-fns/end_of_week";
import addDays from "date-fns/add_days";
import subDays from "date-fns/sub_days";
import startOfMonth from "date-fns/start_of_month";
import endOfMonth from "date-fns/end_of_month";
import startOfYear from "date-fns/start_of_year";
import endOfYear from "date-fns/end_of_year";

const createRange = (date, startFunc, endFunc, args = []) => [
  startFunc(date, ...args),
  endFunc(date, ...args)
];
const prevDay = date => subDays(date, 1);
const nextDay = date => addDays(date, 1);

const rangeFunctions = {
  weekly: date =>
    createRange(date, startOfWeek, endOfWeek, [{ weekStartsOn: 1 }]),
  monthly: date => createRange(date, startOfMonth, endOfMonth),
  yearly: date => createRange(date, startOfYear, endOfYear)
};

const rangeGenerators = _.mapValues(rangeFunctions, rangeFunc => ({
  curr: () => rangeFunc(startOfToday()),
  prev: date => rangeFunc(prevDay(date)),
  next: date => rangeFunc(nextDay(date))
}));

export default {
  model: {
    prop: "dateRange",
    event: "change"
  },
  props: {
    dateRange: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      tabs: [
        { name: "weekly", label: "Weekly" },
        { name: "monthly", label: "Monthly" },
        { name: "yearly", label: "Yearly" }
      ],
      internalDateRange: this.dateRange ? [...this.dateRange] : null,
      mode: "weekly"
    };
  },
  watch: {
    internalDateRange(newVal) {
      this.emitChange(newVal);
    }
  },
  methods: {
    emitChange(data) {
      this.$emit("change", data);
    },
    selectTab(type) {
      this.mode = type;
      const rangeFunc = rangeGenerators[this.mode];
      if (!rangeFunc) {
        throw new Error(`Invalid picker mode: ${this.mode}`);
      }
      const range = rangeFunc.curr();
      this.internalDateRange = range;
      this.emitChange(range);
    },
    changeRange(dir) {
      const newRange = rangeGenerators[this.mode][dir](
        this.dateRange[dir === "prev" ? 0 : 1]
      );
      this.internalDateRange = newRange;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/mixins.scss";
.wrap {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.periods {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.button-time {
  background: white;
  margin: 0 4px;
  border: 1px solid #eee;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &.active {
    background: #2c3e50;
    color: white;
  }
}

.range {
  display: flex;
  align-items: center;
  margin: 10px 0 20px 0;
}

.range-left {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.range-right {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.range-label {
  display: flex;
  align-items: center;
  margin: 0 30px;
  font-size: 30px;
}

.picker {
  width: 350px;
  :global(.el-input__inner) {
    text-align: center;
    font-size: 20px;
  }
  @include MQ(M) {
    width: 100%;
    :global(.el-input__inner) {
      font-size: 14px;
    }
  }
}
</style>
